// "Service needs" tab.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';

export function ServiceNeeds(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Service needs"
      wiringNotes="Open Zoho Desk tickets, ShipStation holds, and shipping issues. Writes go through ZOHO_CREATE_TICKET / SHIPSTATION_HOLD_ORDER / SHIPSTATION_UPDATE_ADDRESS."
    />
  );
}
